import { useEffect } from 'react';
import { useIsFocused } from '@react-navigation/native';

import { useIsLoggedIn } from '@order/AuthMachine';
import {
  useChallengeRewards,
  useChallenges,
} from '@order/ChallengesAndRewards';

/**
 * Refreshes challenges and rewards when the screen gains/regains focus.
 * This necessary because submitting orders can change the status of challenges and rewards.
 * Since the submit order mutation doesn't update the cache, we update it upon re-entering the screen.
 */
export const useSweetpassChallengesAndRewards = () => {
  const isLoggedIn = useIsLoggedIn();

  const { challenges, isFetchingChallenges, fetchChallenges } = useChallenges();
  const {
    challengeRewards,
    isFetchingChallengeRewards,
    fetchChallengeRewards,
  } = useChallengeRewards();

  const isFocused = useIsFocused();

  useEffect(() => {
    if (!isLoggedIn || !isFocused) return;

    fetchChallenges();
    fetchChallengeRewards();
  }, [fetchChallengeRewards, fetchChallenges, isLoggedIn, isFocused]);

  return {
    challenges,
    challengeRewards,
    isFetchingChallenges,
    isFetchingChallengeRewards,
  };
};
